import PropTypes from 'prop-types';

const Tooltip = (props) => {
  const { type, content, closeHandler } = props;

  return (
    <div className={`hint ${type}`}>
      <i className="icon-close" onClick={closeHandler}/>
      <h6 className="hint-title">{content.title}</h6>
      {content.text.map((el, index) => <p className="hint-content" key={index}>{el}</p>)}
      <span>{content.subTitle}</span>
    </div>
  );
};

Tooltip.propTypes = {
  type: PropTypes.string,
  content: PropTypes.object,
  closeHandler: PropTypes.func
};

Tooltip.defaultProps = {
  content: {
    text: []
  },
  closeHandler: () => {}
};

export default Tooltip;
